import { useEffect, useRef, useCallback } from "react";

export const useInactivity = (onInactive, isActive, timeout = 600000) => {
   const timerRef = useRef(null);
   const resetTimer = useCallback(
      (e) => {
         if (timerRef.current) {
            clearTimeout(timerRef.current);
         }
         timerRef.current = setTimeout(onInactive, timeout);
      },
      [onInactive, timeout]
   );

   useEffect(() => {
      if (!isActive) {
         clearTimeout(timerRef.current);
         return;
      }

      const handleActivity = (e) => {
         resetTimer(e);
      };

      window.addEventListener("mousemove", handleActivity);
      window.addEventListener("keydown", handleActivity);

      resetTimer("called from within");

      return () => {
         clearTimeout(timerRef.current);
         window.removeEventListener("mousemove", handleActivity);
         window.removeEventListener("keydown", handleActivity);
      };
   }, [isActive]);

   useEffect(() => {
      if (!isActive) {
         clearTimeout(timerRef.current);
      }
   }, [isActive]);
};
